import { RadioTile, TileGroup } from 'carbon-components-react';
import React, { useEffect } from 'react';
import { QuesIDProps } from '../../Maas360Estimator';
import { segmentsTracking } from 'src/common/lib/tracker';
import { TranslationFunction } from 'src/common/hooks/widgets/useTranslation';
import { convertToString } from 'src/apps/maas360-estimator/lib/utils';

type Step3Props = {
  que3Value: string;
  setQue3Value: React.Dispatch<React.SetStateAction<string>>;
  setIsRequired: React.Dispatch<React.SetStateAction<boolean>>;
  setTrackQuesID: React.Dispatch<React.SetStateAction<QuesIDProps>>;
  trackQuesID: QuesIDProps;
  useTranslation: TranslationFunction;
};

const Step3 = ({
  que3Value,
  setQue3Value,
  setIsRequired,
  setTrackQuesID,
  trackQuesID,
  useTranslation,
}: Step3Props) => {
  useEffect(() => {
    if (que3Value) {
      setIsRequired(false);
    }
  }, []);

  const handleClick = (
    value: string,
    event: React.MouseEvent<HTMLInputElement>,
  ) => {
    setQue3Value(value);
    setIsRequired(false);
    setTrackQuesID({
      ...trackQuesID,
      Q3: (event.target as HTMLInputElement).id,
    });
    segmentsTracking('CTA Clicked', {
      pageTitle: 'MaaS360 Plan Assessment',
      object: 'Mass360 page',
      resultValue: 'CTA clicked',
      CTA: `question 3 - ${value} - selected`,
      location: 'Assessment',
      action: '',
      field: '',
    });
  };

  const yes = convertToString(useTranslation('yes', true));
  const no = convertToString(useTranslation('no', true));

  return (
    <div>
      <div className="page_sub_heading padding_8">
        {useTranslation('que3_text_desc')}
      </div>
      <TileGroup
        name="radio-group"
        className="tilegroup"
        valueSelected={que3Value}
      >
        <RadioTile
          className="tile"
          id="Q3A1"
          value="Yes"
          onClick={(e) => handleClick(yes, e)}
        >
          {useTranslation('yes')}
        </RadioTile>
        <RadioTile
          className="tile"
          id="Q3A2"
          value="No"
          onClick={(e) => handleClick(no, e)}
        >
          {useTranslation('no')}
        </RadioTile>
      </TileGroup>
    </div>
  );
};

export default Step3;
